import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/termsCondition/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/termsCondition/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/termsCondition/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/termsCondition/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/termsCondition/Delete',
    method: 'delete',
    data,
  })
}

export function GetLatestRecord() {
  return request({
    url: '/termsCondition/GetLatestRecord',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
 